import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BudgetProgramCreateEditProvider } from './context/budget-program-create-edit-context';
import { BudgetProgramCreateEditComponent } from './budget-program-create-edit-component';

export function BudgetProgramCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <BudgetProgramCreateEditProvider>
                <BudgetProgramCreateEditComponent />
            </BudgetProgramCreateEditProvider>
        </BaseLayoutFactory>
    );
}
